<template>
  <div id="container" class="container" style="padding: 48px 0 0 0">
    <v-layout column class="menu w-100 white">
      <v-card elevation="2" tile>
        <v-layout
          align-center
          justify-space-around
          class="py-2 px-3 colorSelectedBack sizeTop"
        >
          <img
            :src="require(`@/assets/logos/usecargobranco.png`)"
            alt="pickndrive"
            style="width: auto; height: 39px"
          />
        </v-layout>
      </v-card>
    </v-layout>
    <!-- alertas -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- modal dados -->
    <modal
      :showModal="modalComplete"
      :ifTitle="true"
      :Title="'Por favor, complete seus dados na tela de perfil.'"
      :ifIcon="true"
      :Icon="'account_circle'"
      :ifOneBtn="true"
      :TextOneBtn="'OK'"
      @btnUm="$router.push({ name: 'usr-profile' })"
    ></modal>

    <!-- modal informação -->
    <!-- <ModalInformations
      :show="showSecond && !showModalInformations"
      @close="acceptTerms"
    ></ModalInformations> -->

    <modal
      :showModal="requestCreatedDialog"
      :ifTitle="true"
      :Title="'Reserva realizada com sucesso!'"
      :ifIcon="true"
      :Icon="'alarm_on'"
      :ifOneBtn="true"
      :TextOneBtn="'OK'"
      @btnUm="
        $router.push({ name: 'driver-vehicle-request-dashboard' }),
          (requestCreatedDialog = !requestCreatedDialog)
      "
    ></modal>

    <!-- Modal Loading -->
    <v-dialog persistent max-width="300" v-model="blockScreen">
      <v-card class="px-3 py-5 text-center">
        <div class="text-center pb-5">
          <span class="title font-weight-bold"
            >Aguarde, estamos processando os dados...</span
          >
        </div>
        <v-progress-circular
          :size="70"
          :width="7"
          class="checkin-text"
          indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>

    <verifyNumber
      v-if="showVerifyNumber"
      :show="showVerifyNumber"
      @close="showVerifyNumber = false"
      @closeModal="(showVerifyNumber = false), getUser()"
    ></verifyNumber>

    <ModalCnh
      :show="showCnhModal"
      :internal="true"
      :requiredCnh="requiredCnh"
      @success="onSuccess()"
      @close="showCnhModal = false"
    ></ModalCnh>

    <div
      class="first"
      v-if="showFirst && configurations.vehicle_schedule"
      style="padding-top: 0"
    >
      <div class="home-section" v-if="showHome">
        <!-- Welcome Message -->
        <div class="welcome">
          <div v-if="welcome === 'morning'">
            <span
              >Olá, {{ user.name }}. <br />
              Bom dia!</span
            >
            <img
              :src="require(`@/assets/welcome/morning.jpg`)"
              alt="sol nascendo"
            />
          </div>
          <div v-if="welcome === 'afternoon'">
            <span
              >Olá, {{ user.name }}. <br />
              Boa tarde!</span
            >
            <img
              :src="require(`@/assets/welcome/afternoon.jpg`)"
              alt="sol se pondo"
            />
          </div>
          <div v-if="welcome === 'night'">
            <span style="color: #fff"
              >Olá, {{ user.name }}. <br />
              Boa noite!</span
            >
            <img :src="require(`@/assets/welcome/night.jpg`)" alt="noite" />
          </div>
        </div>

        <v-card elevation="0" class="cardBottom w-100 pa-0 ma-0">
          <div class="content px-3 pt-15 text-center">
            <div>
              <span class="subheading font-weight-medium">
                Data e hora do
                <span class="checkin-text">check-in</span>
              </span>
              <div class="inputs mt-1 mb-5 pa-2">
                <datetime
                  input-id="inputDateCheckIn"
                  type="datetime"
                  value-zone="America/Sao_Paulo"
                  zone="America/Sao_Paulo"
                  :min-datetime="dateNow()"
                  :minute-step="getConfigMinuteStep()"
                  v-model="vehicleRequest.begin_date"
                ></datetime>
              </div>
            </div>

            <div>
              <span class="subheading font-weight-medium">
                Data e hora do
                <span class="checkout-text">check-out</span>
              </span>
              <div class="inputs mt-1 mb-10 pa-2">
                <datetime
                  input-id="inputDateCheckOut"
                  type="datetime"
                  value-zone="America/Sao_Paulo"
                  zone="America/Sao_Paulo"
                  :min-datetime="dateNow()"
                  :minute-step="getConfigMinuteStep()"
                  v-model="vehicleRequest.end_date"
                ></datetime>
              </div>
            </div>

            <div>
              <v-btn
                :disabled="validadeDates"
                @click="checkCnh()"
                depressed
                large
                style="width: 85vw"
                class="colorBtn button mt-3 white--text"
              >
                <span class="button-text">PRÓXIMA ETAPA</span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>

      <vehicleSchedule
        v-if="vehicleScheduleShow"
        :show="vehicleScheduleShow"
        :date="vehicleRequest.begin_date"
        @close="vehicleScheduleShow = false"
      ></vehicleSchedule>
    </div>

    <div
      class="first"
      v-if="showFirst && !configurations.vehicle_schedule"
      style="padding-top: 0"
      id="first"
    >
      <v-btn class="d-flex flex-column qrcode-btn" @click="scanQRCode()">
        <img src="../../assets/qr-code.png" style="width: 40px; height: auto" />
        <span>ESCANEAR</span>
      </v-btn>

      <googleMapsVehicles id="vehiclesMap" @selectedVehicle="selectedVehicle" />

      <div v-if="vehiclesSelectedGarage.length > 0">
        <v-card elevation="4" class="cardRadius vehicle mt-2 pa-3 card-vehicle">
          <v-carousel height="170" hide-delimiters>
            <v-carousel-item
              v-for="vehicle in vehiclesSelectedGarage"
              :key="vehicle.id"
            >
              <v-row class="cardVehicle">
                <div class="contentLeft">
                  <img
                    class="vehicleImg"
                    style="max-width: 150px; height: auto"
                    :src="`${url_bucket + vehicle.url}`"
                  />
                  <div class="contentBottom pt-2">
                    <span class="body-1">Placa:</span>
                    <span class="pl-2 body-1">{{ vehicle.plate }}</span>
                  </div>
                  <br />
                </div>
                <div class="contentRight pt-1 pl-2">
                  <span class="modelo">
                    {{ vehicle.model }}
                  </span>
                  <div class="pb-1">
                    <img src="../../assets/icons/icon3.png" />
                    <span class="pl-2 caption">Flex</span>
                  </div>
                  <div class="pb-1">
                    <img src="../../assets/icons/icon4.png" />
                    <span class="pl-2 caption"
                      >{{ vehicle.doors_qtd }} Portas</span
                    >
                  </div>
                  <div class="pb-1">
                    <img src="../../assets/icons/icon5.png" />
                    <span class="pl-2 caption">Ar Condicionado</span>
                  </div>
                </div>
              </v-row>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </div>
    </div>

    <div
      class="first"
      v-if="showSecond && !configurations.vehicle_schedule"
      style="padding-top: 0"
    >
      <div class="home-section" v-if="showHome">
        <v-card elevation="4" class="cardRadius vehicle pa-3">
          <v-col class="pa-8">
            <v-row>
              <div class="contentLeft">
                <span class="modelo">
                  {{ vehicleRequest.vehicle.brand }} -
                  {{ vehicleRequest.vehicle.model }}
                </span>
                <br />
                <img
                  class="vehicleImg"
                  style="max-width: 186px; height: auto"
                  :src="`${url_bucket + vehicleRequest.vehicle.url}`"
                />
                <br />
              </div>
              <div class="contentRight pt-1 pl-2">
                <div class="pb-1">
                  <img src="../../assets/icons/icon2.png" />
                  <span class="pl-2 caption">{{
                    vehicleRequest.vehicle.gearbox
                      ? vehicleRequest.vehicle.gearbox
                      : 'Manual'
                  }}</span>
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon3.png" />
                  <span class="pl-2 caption">Flex</span>
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon4.png" />
                  <span class="pl-2 caption"
                    >{{ vehicleRequest.vehicle.doors_qtd }} Portas</span
                  >
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon5.png" />
                  <span class="pl-2 caption">Ar Condicionado</span>
                </div>
              </div>
            </v-row>

            <v-row>
              <div class="contentBottom pt-2">
                <span class="body-1">Placa:</span>
                <span class="pl-2 body-1">{{
                  vehicleRequest.vehicle.plate
                }}</span>
                <br />
                <span class="body-1">Localização:</span>
                <span class="pl-2 body-1">{{ address }}</span>
              </div>
            </v-row>
          </v-col>
        </v-card>
        <v-card elevation="0" class="cardBottom w-100 pa-0 ma-0">
          <div class="content px-3 pt-5 text-center">
            <div>
              <span class="subheading font-weight-medium">
                Data e hora do
                <span class="checkin-text">check-in</span>
              </span>
              <div class="inputs mt-1 mb-5 pa-2">
                <datetime
                  input-id="inputDateCheckIn"
                  type="datetime"
                  value-zone="America/Sao_Paulo"
                  zone="America/Sao_Paulo"
                  :min-datetime="dateNow()"
                  :minute-step="getConfigMinuteStep()"
                  v-model="vehicleRequest.begin_date"
                  disabled
                ></datetime>
              </div>
            </div>

            <div>
              <span class="subheading font-weight-medium">
                Data e hora do
                <span class="checkout-text">check-out</span>
              </span>
              <div class="inputs mt-1 mb-10 pa-2">
                <datetime
                  input-id="inputDateCheckOut"
                  type="datetime"
                  value-zone="America/Sao_Paulo"
                  zone="America/Sao_Paulo"
                  :min-datetime="dateNow()"
                  :minute-step="getConfigMinuteStep()"
                  v-model="vehicleRequest.end_date"
                ></datetime>
              </div>
            </div>

            <div>
              <v-btn
                :disabled="validadeDates"
                @click="nextStep()"
                depressed
                large
                style="width: 85vw"
                class="colorBtn button mt-3 mb-4 white--text"
              >
                <span class="button-text">PRÓXIMA ETAPA</span>
              </v-btn>

              <terms
                :show="termsDialog"
                :configs="this.configurations"
                :showButtons="true"
                @closeTermsDialog="termsDialog = !termsDialog"
                @requestCreate="aceitarTermoDeUso()"
                @sendTermsByEmail="sendTermsByEmail()"
              ></terms>
            </div>
          </div>
        </v-card>
      </div>

      <vehicleSchedule
        v-if="vehicleScheduleShow"
        :show="vehicleScheduleShow"
        :date="vehicleRequest.begin_date"
        @close="vehicleScheduleShow = false"
      ></vehicleSchedule>
    </div>

    <div
      v-if="showSecond && configurations.vehicle_schedule"
      class="second pa-3 mt-5"
    >
      <v-card text class="cardRadius checkinBorder">
        <div class="white--text checkin pa-1 subheading text-center">
          Check-in
        </div>
        <div class="pa-1 cardContent">
          <span class="subheading sizePart">{{
            formatDate('hora', 'check-in')
          }}</span>
          <v-divider vertical class="checkin"></v-divider>
          <span class="subheading sizePart">{{
            formatDate('min', 'check-in')
          }}</span>
        </div>
      </v-card>

      <v-card text class="cardRadius checkoutBorder mt-2 mb-4">
        <div class="white--text checkout pa-1 subheading text-center">
          Check-out
        </div>
        <div class="pa-1 cardContent">
          <span class="subheading sizePart">{{
            formatDate('hora', 'check-out')
          }}</span>
          <v-divider vertical class="checkout"></v-divider>
          <span class="subheading sizePart">{{
            formatDate('min', 'check-out')
          }}</span>
        </div>
      </v-card>

      <div class="w-100 text-center">
        <span
          v-if="vehicles.length > 0"
          class="cardTitle grey--text text--darken-1 font-weight-regular"
          >Escolha um carro</span
        >
        <span
          v-if="vehicles.length == 0 && sharedRequests.length == 0"
          class="cardTitle grey--text text--darken-1 font-weight-regular"
          >Nenhum veículo disponível para o horario selecionado</span
        >
      </div>

      <div v-for="(vehicle, index) in vehicles" :key="index">
        <v-card
          text
          :class="vehicle.id == vehicleCardSelected ? 'carSelected' : ''"
          class="cardRadius mt-2 mb-4"
          @click="selectVehicle(vehicle.id)"
        >
          <v-col>
            <v-row>
              <div class="contentLeft">
                <span class="modelo">
                  {{ vehicle.brand }} - {{ vehicle.model }}
                </span>
                <img
                  class="vehicleImg"
                  style="max-width: 186px; height: auto"
                  :src="`${url_bucket + vehicle.url}`"
                />
                <br />
              </div>
              <div class="contentRight pt-1 pl-2">
                <div class="pb-1">
                  <img src="../../assets/icons/icon2.png" />
                  <span class="pl-2 caption">{{
                    vehicle.gearbox ? vehicle.gearbox : 'Manual'
                  }}</span>
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon3.png" />
                  <span class="pl-2 caption">Flex</span>
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon4.png" />
                  <span class="pl-2 caption"
                    >{{ vehicle.doors_qtd }} Portas</span
                  >
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon5.png" />
                  <span class="pl-2 caption">Ar Condicionado</span>
                </div>
              </div>
            </v-row>

            <v-row>
              <div class="contentBottom pt-2">
                <span class="body-1">Placa:</span>
                <span class="pl-2 body-1">{{ vehicle.plate }}</span>
                <br />
                <div v-if="!vehicle.shared">
                  <span class="body-1">Garagem:</span>
                  <span class="pl-2 body-1">{{ vehicle.description }}</span>
                  <br />
                </div>
                <div v-if="!vehicle.shared">
                  <span class="body-1">Endereço:</span>
                  <span class="pl-2 body-1">{{
                    vehicle.address_formatted
                  }}</span>
                  <br />
                </div>
              </div>
            </v-row>
          </v-col>
        </v-card>
      </div>

      <div v-for="(vehicleRequest, index) in sharedRequests" :key="index">
        <v-card
          text
          :class="
            vehicleRequest.vehicle.id == vehicleCardSelected
              ? 'carSelected'
              : ''
          "
          class="cardRadius mt-2 mb-4"
          @click="selectRequest(vehicleRequest)"
        >
          <div class="white--text checkout pa-1 subheading text-center">
            Reserva compartilhada
          </div>
          <v-col>
            <v-row>
              <div class="contentLeft">
                <span class="modelo">
                  {{ vehicleRequest.vehicle.brand }} -
                  {{ vehicleRequest.vehicle.model }}
                </span>
                <img
                  class="vehicleImg"
                  style="max-width: 186px; height: auto"
                  :src="
                    `${url_bucket + vehicleRequest.vehicle.vehicle_model.url}`
                  "
                />
                <br />
              </div>
              <div class="contentRight pt-1 pl-2">
                <div class="pb-1">
                  <img src="../../assets/icons/icon2.png" />
                  <span class="pl-2 caption">{{
                    vehicleRequest.vehicle.gearbox
                      ? vehicleRequest.vehicle.gearbox
                      : 'Manual'
                  }}</span>
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon3.png" />
                  <span class="pl-2 caption">Flex</span>
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon4.png" />
                  <span class="pl-2 caption"
                    >{{ vehicleRequest.vehicle.doors_qtd }} Portas</span
                  >
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon5.png" />
                  <span class="pl-2 caption">Ar Condicionado</span>
                </div>
              </div>
            </v-row>

            <v-row>
              <div class="contentBottom pt-2">
                <span class="body-1">Placa:</span>
                <span class="pl-2 body-1">{{
                  vehicleRequest.vehicle.plate
                }}</span>
                <br />
              </div>
            </v-row>
            <v-row>
              <span
                style="
                  padding: 15px;
                  margin-bottom: 20px;
                  font-size: 10px;
                  text-align: justify;
                  display: block;
                "
                >Reserva para o motorista
                <strong>{{ vehicleRequest.user.name }}</strong>
                ({{ vehicleRequest.user.email }}) e de outros
                {{ vehicleRequest.request_user_group.length }}
                passageiros, saindo de
                {{
                  vehicleRequest.shared_vehicle_request.point_begin
                    .point_address.address_format
                }}
                ({{ vehicleRequest.shared_vehicle_request.point_begin.name }})
                no dia
                {{ vehicleRequest.begin_date | normalizeDay }}
                às
                {{ vehicleRequest.begin_date | normalizeTime }}, com retorno de
                {{
                  vehicleRequest.shared_vehicle_request.point_end.point_address
                    .address_format
                }}
                ({{ vehicleRequest.shared_vehicle_request.point_end.name }}) no
                dia {{ vehicleRequest.end_date | normalizeDay }} às
                {{ vehicleRequest.end_date | normalizeTime }}
              </span>
            </v-row>
          </v-col>
          <div class="white--text checkout pa-1 subheading text-center">
            {{ 4 - vehicleRequest.request_user_group.length }} vagas disponíveis
          </div>
        </v-card>
      </div>
      <div style="height: 48px"></div>
    </div>

    <div
      class="content px-2 mb-2 fab text-center"
      v-if="showSecond && configurations.vehicle_schedule"
    >
      <v-btn
        large
        depressed
        :disabled="!isVehicleSelected"
        @click="nextPage()"
        class="floatBtn button-text colorBtn white--text"
        style="width: 96vw"
      >
        <span class="button-text">PRÓXIMA ETAPA</span>
      </v-btn>
    </div>

    <div v-if="showThird && !vehicleRequest.shared_request" class="pa-3 mt-5">
      <v-card text class="cardRadius">
        <v-card-title class="justify-center cardTitleV2">
          <span class="titulo">Detalhes da reserva</span>
        </v-card-title>

        <v-card-text>
          <v-col class="text-center">
            <v-row align="center" justify="center">
              <span class="modelo">
                {{ vehicleRequest.vehicle.brand }} -
                {{ vehicleRequest.vehicle.model }}
              </span>
            </v-row>

            <v-row align="center" justify="center">
              <span class="plate">Placa:</span>
              <span class="plate">
                {{ vehicleRequest.vehicle.plate }}
              </span>
            </v-row>
            <img
              class="vehicleImg"
              style="max-width: 186px; height: auto"
              :src="`${url_bucket + vehicleRequest.vehicle.url}`"
            />
            <v-row align="center" justify="center">
              <img src="../../assets/icons/icon2.png" />
              <span class="pl-2 caption">{{
                vehicleRequest.vehicle.gearbox
                  ? vehicleRequest.vehicle.gearbox
                  : 'Manual'
              }}</span>

              <v-spacer></v-spacer>
              <img src="../../assets/icons/icon3.png" />
              <span class="pl-2 caption">Flex</span>

              <v-spacer></v-spacer>
              <img src="../../assets/icons/icon5.png" />
              <span class="pl-2 caption">Ar Cond.</span>

              <v-spacer></v-spacer>
              <img src="../../assets/icons/icon4.png" />
              <span class="pl-2 caption"
                >{{ vehicleRequest.vehicle.doors_qtd }} Portas</span
              >
            </v-row>
          </v-col>
          <div>
            <v-row align="center" justify="center" class="conteudo">
              <v-col align="center" justify="center">
                <span class="subtitulo">Check-in</span>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col align="center" justify="center">
                <span class="subtitulo">Check-out</span>
              </v-col>
            </v-row>

            <v-row align="center" justify="center" class="conteudo">
              <v-col align="center" justify="center">
                <span
                  class="body-1 grey--text text--darken-1 mx-auto sizePart"
                  >{{ formatDate('hora', 'check-in') }}</span
                >
                -
                <span
                  class="body-1 grey--text text--darken-1 mx-auto sizePart"
                  >{{ formatDate('min', 'check-in') }}</span
                >
              </v-col>
              <v-col align="center" justify="center">
                <span
                  class="body-1 grey--text text--darken-1 mx-auto sizePart"
                  >{{ formatDate('hora', 'check-out') }}</span
                >
                -
                <span
                  class="body-1 grey--text text--darken-1 mx-auto sizePart"
                  >{{ formatDate('min', 'check-out') }}</span
                >
              </v-col>
            </v-row>
            <v-row
              v-if="configurationsFrotas.shared_request"
              align="center"
              justify="center"
            >
              <div>
                <v-card-text align="center" justify="center" class="body-1">
                  <div class="pb-1">
                    <img
                      style="margin-top: 5px;"
                      src="../../assets/icons/pin.png"
                    /><span class="point">Garagem</span>
                  </div>
                </v-card-text>
              </div>
            </v-row>
            <v-row
              v-if="configurationsFrotas.shared_request"
              align="center"
              justify="center"
            >
              <span class="pl-2 caption">{{
                vehicleRequest.vehicle.address_formatted
              }}</span>
            </v-row>
          </div>

          <!--
          <v-card text class="cardRadius border mx-3">
            <div
              class="
                grey--text
                text--darken-1
                borderBottom
                pa-1
                body-1
                text-center
              "
            >
              Data e hora do check-in
            </div>
            <div class="pa-1 cardContent">
              <span class="body-1 grey--text text--darken-1 mx-auto sizePart">{{
                formatDate('hora', 'check-in')
              }}</span>
              <v-divider vertical class="grey"></v-divider>
              <span class="body-1 grey--text text--darken-1 mx-auto sizePart">{{
                formatDate('min', 'check-in')
              }}</span>
            </div>
          </v-card>

          <v-card text class="cardRadius border mx-3 mt-3 mb-4">
            <div
              class="
                grey--text
                text--darken-2
                pa-1
                borderBottom
                body-1
                text-center
              "
            >
              Data e hora do check-out
            </div>
            <div class="pa-1 cardContent">
              <span class="body-1 grey--text text--darken-1 mx-auto sizePart">{{
                formatDate('hora', 'check-out')
              }}</span>
              <v-divider vertical class="grey"></v-divider>
              <span class="body-1 grey--text text--darken-1 mx-auto sizePart">{{
                formatDate('min', 'check-out')
              }}</span>
            </div>
          </v-card> -->
        </v-card-text>
      </v-card>
      <div>
        <v-card-text
          v-if="configurationsFrotas.shared_request"
          align="center"
          justify="center"
          class="body-1"
        >
          <span class="point">Destino</span>
        </v-card-text>
      </div>
      <v-flex v-if="configurationsFrotas.shared_request">
        <v-select
          v-model="selectedPoint"
          :items="computedUsers"
          item-text="name"
          item-value="id"
          label="Destino"
          full-width
          solo
        >
          <template v-slot:selection="{ item }">
            <span class="selectPoint"
              >{{ item.name }} -
              {{ item.point_address.address_formatted }}</span
            >
          </template>
        </v-select>
      </v-flex>
      <v-btn
        v-if="configurationsFrotas.shared_request"
        depressed
        large
        class="w-100 colorBtn bottom button cardRadius white--text"
        @click="verificaTermoDeUso()"
        :disabled="!selectedPoint"
      >
        <span class="button-text">FAZER RESERVA</span>
      </v-btn>

      <v-btn
        v-if="!configurationsFrotas.shared_request"
        depressed
        large
        class="w-100 colorBtn bottom button cardRadius mt-4 white--text"
        @click="verificaTermoDeUso()"
      >
        <span class="button-text">FAZER RESERVA</span>
      </v-btn>
    </div>

    <div v-if="showThird && vehicleRequest.shared_request" class="pa-3 mt-5">
      <v-card text class="cardRadius">
        <v-card-title class="justify-center cardTitleV2">
          <span class="titulo">Detalhes da reserva</span>
        </v-card-title>

        <v-card-text>
          <v-col class="text-center">
            <v-row align="center" justify="center">
              <span class="modelo">
                {{ vehicleRequest.vehicle.vehicle_model.brand }}
                -
                {{ vehicleRequest.vehicle.vehicle_model.model }}
              </span>
            </v-row>

            <v-row align="center" justify="center">
              <span class="plate">Placa:</span>
              <span class="plate">
                {{ vehicleRequest.vehicle.plate }}
              </span>
            </v-row>
            <img
              class="vehicleImg"
              style="max-width: 186px; height: auto"
              :src="`${url_bucket + vehicleRequest.vehicle.vehicle_model.url}`"
            />
            <v-row align="center" justify="center">
              <img src="../../assets/icons/icon2.png" />
              <span class="pl-2 caption">{{
                vehicleRequest.vehicle.gearbox
                  ? vehicleRequest.vehicle.gearbox
                  : 'Manual'
              }}</span>

              <v-spacer></v-spacer>
              <img src="../../assets/icons/icon3.png" />
              <span class="pl-2 caption">Flex</span>

              <v-spacer></v-spacer>
              <img src="../../assets/icons/icon5.png" />
              <span class="pl-2 caption">Ar Cond.</span>

              <v-spacer></v-spacer>
              <img src="../../assets/icons/icon4.png" />
              <span class="pl-2 caption"
                >{{ vehicleRequest.vehicle.doors_qtd }} Portas</span
              >
            </v-row>
          </v-col>
          <div>
            <v-row align="center" justify="center" class="passageiros">
              <span class="passageiros-text">Passageiros</span>
            </v-row>

            <v-row align="left" justify="left">
              <v-col align="left" justify="left">
                <img src="../../assets/icons/volante.png" />
                {{ vehicleRequest.user.name.substr(0, 13) }}
                <span class="text-center grey--text"> &nbsp; (Motorista)</span>
              </v-col>
            </v-row>

            <div
              v-for="(item, index) in vehicleRequest.request_user_group"
              :key="index"
            >
              <v-row align="left" justify="left">
                <v-col align="left" justify="left">
                  <img src="../../assets/icons/profile.png" />
                  {{ item.user.name.substr(0, 13) }}
                  <span class="text-center grey--text">
                    &nbsp; (Passageiro)</span
                  >
                </v-col>
              </v-row>
            </div>

            <v-row align="center" justify="center" class="conteudo">
              <v-col align="center" justify="center">
                <span class="subtitulo">Origem</span>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col align="center" justify="center">
                <img src="../../assets/icons/icon2.png" /><span
                  class="subtitulo"
                  >Destino</span
                >
              </v-col>
            </v-row>

            <v-row align="center" justify="center">
              <v-col align="center" justify="center">
                <span>
                  {{
                    vehicleRequest.shared_vehicle_request.point_begin
                      .point_address.address_format
                  }}
                </span>
                <span class="subtitulo">
                  ({{ vehicleRequest.shared_vehicle_request.point_begin.name }})
                </span>
              </v-col>
              <v-col align="center" justify="center">
                <span>
                  {{
                    vehicleRequest.shared_vehicle_request.point_end
                      .point_address.address_formatte
                  }}
                  <span class="subtitulo">
                    ({{ vehicleRequest.shared_vehicle_request.point_end.name }})
                  </span>
                </span>
              </v-col>
            </v-row>
          </div>
          <div>
            <v-row align="center" justify="center" class="conteudo">
              <v-col align="center" justify="center">
                <span class="subtitulo">Check-in previsto</span>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col align="center" justify="center">
                <span class="subtitulo">Check-out previsto</span>
              </v-col>
            </v-row>

            <v-row align="center" justify="center">
              <v-col align="center" justify="center">
                <span
                  class="body-1 grey--text text--darken-1 mx-auto sizePart"
                  >{{ formatDate('hora', 'check-in') }}</span
                >
                -
                <span
                  class="body-1 grey--text text--darken-1 mx-auto sizePart"
                  >{{ formatDate('min', 'check-in') }}</span
                >
              </v-col>
              <v-col align="center" justify="center">
                <span
                  class="body-1 grey--text text--darken-1 mx-auto sizePart"
                  >{{ formatDate('hora', 'check-out') }}</span
                >
                -
                <span
                  class="body-1 grey--text text--darken-1 mx-auto sizePart"
                  >{{ formatDate('min', 'check-out') }}</span
                >
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
      <v-btn
        depressed
        large
        class="w-100 colorBtn bottom button cardRadius mt-4 white--text"
        @click="includePassenger()"
      >
        <span class="button-text">ENTRAR NA RESERVA</span>
      </v-btn>
    </div>

    <terms
      :show="termsDialog"
      :configs="this.configurations"
      :showButtons="true"
      @closeTermsDialog="termsDialog = !termsDialog"
      @requestCreate="aceitarTermoDeUso()"
      @sendTermsByEmail="sendTermsByEmail()"
    ></terms>
  </div>
</template>

<script>
import { Datetime } from 'vue-datetime';
import moment from 'moment';
import googleMapsMarkers from './GoogleMapsMarkers';
import googleMapsVehicles from './GoogleMapsVehicleSchedule';
import Configuration from '../../controllers/ConfigurationController.js';
import VehicleController from '../../controllers/VehicleController';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import CreditCardController from '../../controllers/UserCreditCardController';
import UserController from '../../controllers/UserController';
import User from './../../models/User.js';
import VehicleRequest from '../../models/VehicleRequest.js';
import Constants from '../../models/constants/Constants.js';
import theming from '../../mixins/theming';
import modal from './ModalPadrao.vue';
import payment from './../user/ModalPayment.vue';
import terms from './../shared/NewUserTerms.vue';
import NumberHelper from './../../helpers/NumberHelper';
import VerifyNumber from '../user/ModalVerifyNumber.vue';
import vehicleSchedule from '../user/ModalVehicleSchedule.vue';
import ModalInformations from '../user/ModalInformations.vue';
import CardIcon from '../public/CardIcon';
import WalletPayment from '../user/WalletPayment';
import TermoDeUsoController from '../../controllers/TermoDeUsoController';
import ModalNotificationWallet from '../user/ModalNotificationWallet';
import CnhController from '../../controllers/CnhController';
import ModalCnh from '../user/ModalCnh';
import Information from '../shared/ReservationInformation.vue';
import PointController from '../../controllers/PointController.js';
import Template from '../user/Template.vue';

export default {
  mixins: [theming],
  components: {
    Datetime,
    googleMapsMarkers,
    googleMapsVehicles,
    modal,
    payment,
    terms,
    verifyNumber: VerifyNumber,
    vehicleSchedule,
    ModalInformations,
    CardIcon,
    WalletPayment,
    ModalNotificationWallet,
    ModalCnh,
    Information,
    Template,
  },
  async created() {
    this.blockScreen = true;
    // this.showModalInformations = localStorage.getItem('accept_terms');
    localStorage.setItem('accept_terms', true);
    //
    this.vehicleRequest.client_id = localStorage.getItem('client_id');
    this.getConfigurations().then(() => (this.showHome = true));
    await this.getUser();
    await this.setWelcomeMessage();
    await this.getConfigurationsFrotas();
    await this.getPoints();

    this.blockScreen = false;
    var done = function(err, status) {
      if (err) {
        console.error(err._message);
      } else {
        //www.youtube.com/watch?v=GQg8l1eapsI
        https: console.log(status);
      }
    };

    await window.QRScanner.prepare(done);
  },

  updated() {
    if (this.showFirst === true) this.scroolTo();
  },

  filters: {
    formatPrice(price) {
      return NumberHelper.formatPrice(price);
    },
    money(str) {
      str = 'R$ ' + parseFloat(str / 100).toFixed(2);
      return str.replace('.', ',');
    },
    normalizeDate(date) {
      moment.locale('pt-Br');
      return moment(date).format('DD[/]MM[/]YYYY [-] HH:mm');
    },
    normalizeDay(date) {
      moment.locale('pt-Br');
      return moment(date).format('DD[/]MM');
    },
    normalizeTime(date) {
      moment.locale('pt-Br');
      return moment(date).format('HH:mm');
    },
  },

  data() {
    return {
      colors: ['primary', 'secondary', 'yellow darken-2', 'red', 'orange'],
      attachedCnh: true,
      requiredCnh: false,
      welcome: '',
      paymentOptions: [],
      showCards: false,
      showWalletPayment: false,
      selectedPayment: null,
      dialog: false,
      isDisabled: true,
      beginDate: '',
      endDate: '',
      userController: new UserController(this.$resource),
      user: new User(),
      showFirst: true,
      showSecond: false,
      showThird: false,
      creditCard: '',
      coupon: '',
      configurationController: new Configuration(this.$resource),
      vehicleController: new VehicleController(this.$resource),
      termoDeUsoController: new TermoDeUsoController(this.$resource),
      cnhController: new CnhController(this.$resource),
      configurations: {
        payment: { value: null },
        longitude_visualization: { value: null },
        latitude_visualization: { value: null },
        request_end_wait_timespan_in_minutes: { value: null },
      },
      vehicles: [],
      vehicleRequest: new VehicleRequest(),
      vehicleRequestController: new VehicleRequestController(this.$resource),
      pricePreview: '0,00',
      preAuthorizationValue: '0,00',
      isVehicleSelected: false,
      vehicleCardSelected: '',
      cod_coupon: '',
      validate_coupon: false,
      cards: [],
      creditCardController: new CreditCardController(this.$resource),
      selectedCard: null,
      blockScreen: false,
      showHome: true,
      snackbar: false,
      snackbarColor: '',
      snackbarText: '',
      modalComplete: false,
      newCard: false,
      termsDialog: false,
      requestCreatedDialog: false,
      banners: [],
      showTopMenu: false,
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
      showVerifyNumber: false,
      showCnhModal: false,
      vehicleScheduleShow: false,
      parcelamento: [],
      showInstallments: false,
      // showModalInformations: false,
      typeClient: localStorage.getItem('type_client'),
      showNotificationWallet: false,
      walletNotificationAccepted: false,
      vehiclesInArea: null,
      vehiclesSelectedGarage: [],
      scannedVehicle: null,
      address: '',
      model: 0,
      sharedRequests: [],
      pointController: new PointController(this.$resource),
      points: [],
      selectedPoint: null,
      configurationsFrotas: {},
    };
  },
  computed: {
    validadeDates() {
      if (
        this.vehicleRequest.begin_date < this.vehicleRequest.end_date &&
        this.vehicleRequest.begin_date &&
        this.vehicleRequest.end_date
      ) {
        this.scroolTo();
        return false;
      }
      return true;
    },
    computedUsers() {
      this.points.forEach((point, pointIndex) => {
        if (point.categories == 'Garagem') {
          this.$delete(this.points, pointIndex);
        }
      });
      return this.points;
    },
  },

  methods: {
    sendTermsByEmail() {
      // mandar email com o termo para o usuário
    },

    setWelcomeMessage() {
      const currentDate = new Date();
      const currentHour = currentDate.getHours();

      if (currentHour >= 6 && currentHour < 12) this.welcome = 'morning';
      else if (currentHour >= 12 && currentHour < 18)
        this.welcome = 'afternoon';
      else this.welcome = 'night';
    },

    acceptTerms() {
      localStorage.setItem('accept_terms', true);
      // this.showModalInformations = true;
    },

    onSuccess() {
      this.showCnhModal = false;
      this.requiredCnh = false;
      this.getVehiclesAvailable();
    },

    close() {
      this.newCard = !this.newCard;
      this.getCards();
      this.selectedPayment = null;
    },

    async getUser() {
      await this.userController
        .getUserData()
        .then(res => {
          this.user = res.user;
          this.verifyNumber();
        })
        .catch(error => {
          console.log(error);
          if (error.body) {
            this.snackbarColor = 'error';
            this.snackbarText = error.body.message;
            this.snackbar = true;
          }
        });
    },

    verifyNumber() {
      if (
        this.user.phone === null ||
        this.user.confirmed_sms != true ||
        this.user.phone === ''
      ) {
        this.showVerifyNumber = true;
      }
    },

    async verifyCnhUpload() {
      await this.cnhController.consultarCnhValidaByUserId().then(
        res => {
          if (res.length == 0) {
            this.showCnhModal = true;
            this.attachedCnh = false;
          } else {
            this.showCnhModal = false;
            this.requiredCnh = false;
            this.attachedCnh = true;
          }
        },
        err => {
          console.log(err);
        }
      );
    },

    ifComplete() {
      if (
        this.user.cpf === null ||
        this.user.drive_license === null ||
        this.birthday === null
      )
        this.modalComplete = true;
    },

    alert(alert) {
      this.snackbarText = alert.text;
      this.snackbarColor = alert.color;
      this.snackbar = true;
    },

    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },

    scroolTo() {
      window.scrollTo(0, 0);
    },

    async getConfigurations() {
      let configs = await this.configurationController.getAll(
        this.vehicleRequest.client_id
      );
      this.configurations = configs;
    },

    getConfigMinuteStep() {
      let valueNotEmpty =
        this.configurations.request_end_wait_timespan_in_minutes.value !== '';
      if (
        this.configurations.request_end_wait_timespan_in_minutes.value ||
        valueNotEmpty
      ) {
        return Number(
          this.configurations.request_end_wait_timespan_in_minutes.value
        );
      }
      return Number(Constants.CONFIG_MINUTE_STEP_DATE_TIME_DEFAULT);
    },

    formatDate(type, step) {
      let beginDate = new Date(this.vehicleRequest.begin_date);
      let endDate = new Date(this.vehicleRequest.end_date);
      if (type == 'hora' && step == 'check-in') {
        return moment(beginDate).format('DD/MM/YYYY');
      } else if (type == 'min' && step == 'check-in') {
        return moment(beginDate).format('HH:mm');
      } else if (type == 'hora' && step == 'check-out') {
        return moment(endDate).format('DD/MM/YYYY');
      } else if (type == 'min' && step == 'check-out') {
        return moment(endDate).format('HH:mm');
      }
    },

    async checkCnh() {
      this.getVehiclesAvailable();
    },

    getVehiclesAvailable() {
      if (
        this.vehicleRequest.begin_date.length > 0 &&
        this.vehicleRequest.end_date.length > 0
      ) {
        if (new Date(this.vehicleRequest.begin_date) < new Date()) {
          this.vehicles = [];
          this.showAlert(
            'error',
            'Data de início deve ser maior que a data atual!'
          );
        } else {
          if (this.vehicleRequest.begin_date < this.vehicleRequest.end_date) {
            this.vehicleController
              .getVehiclesAvailable(
                this.vehicleRequest.begin_date,
                this.vehicleRequest.end_date,
                this.vehicleRequest.client_id,
                null,
                null
              )
              .then(res => {
                this.vehicles = res.data;
                this.sharedRequests = res.shared;
                if (
                  this.vehicles.length == 0 &&
                  this.sharedRequests.length == 0
                ) {
                  this.vehicleScheduleShow = true;
                  this.vehicles = [];
                } else {
                  this.showFirst = !this.showFirst;
                  this.showSecond = !this.showSecond;
                  this.scroolTo();
                }
              });
          } else {
            this.vehicles = [];
            this.showAlert(
              'error',
              'Data de início deve ser menor que a data de fim!'
            );
          }
        }
      }
    },

    showAlert(type, text) {
      this.snackbarColor = type;
      this.snackbarText = text;
      this.snackbar = true;
    },

    async includePassenger() {
      this.blockScreen = true;
      await this.vehicleRequestController
        .includePassenger(
          localStorage.getItem('pickn_user'),
          this.vehicleRequest.id,
          this.vehicleRequest.shared_vehicle_request.id
        )
        .then(res => {
          localStorage.setItem('showInfo', Boolean(false));
          this.$router.push('/user/informacao-reserva');
        })
        .catch(error => {
          console.error(error);
          this.snackbarColor = 'error';
          this.snackbarText = error.body.message
            ? error.body.message
            : 'Erro ao solicitar reserva.';
          this.snackbar = true;
        })
        .finally(() => {
          this.blockScreen = false;
        });
    },

    async nextPage() {
      this.showSecond = !this.showSecond;
      this.showThird = !this.showThird;
      this.scroolTo();
      if (!this.vehicleRequest.shared_request) {
        this.vehicleRequest.vehicle = this.vehicles.find(
          vehicle => vehicle.id == this.vehicleRequest.vehicle_id
        );
      }
    },

    async previusPage() {
      this.showSecond = !this.showSecond;
      this.showThird = !this.showThird;
      this.scroolTo();
      this.vehicleRequest.vehicle = null;
    },

    selectVehicle(id) {
      this.vehicleRequest.vehicle_id = id;
      this.isVehicleSelected = true;
      this.vehicleCardSelected = id;
    },

    selectRequest(vehicleRequest) {
      console.log(vehicleRequest);
      this.vehicleRequest = vehicleRequest;
      this.vehicleRequest.vehicle_id = vehicleRequest.vehicle.id;
      this.isVehicleSelected = true;
      this.vehicleCardSelected = vehicleRequest.vehicle.id;
    },

    async verificaTermoDeUso() {
      let termoDeUso = await this.termoDeUsoController.getByUserId();
      let versaoTermoDeUso = Number.parseFloat(
        this.configurations.term_of_use_version.value
      );
      let versaoAprovada = termoDeUso
        ? Number.parseFloat(termoDeUso.versao)
        : 0.0;
      if (versaoTermoDeUso > versaoAprovada) {
        this.termsDialog = true;
      } else {
        this.requestCreate();
      }
    },

    aceitarTermoDeUso() {
      this.termoDeUsoController.create({
        termo_de_uso: this.configurations.term_of_use.value,
        versao: this.configurations.term_of_use_version.value,
        user_id: localStorage.getItem('pickn_user'),
      });
      this.requestCreate();
    },

    async requestCreate() {
      this.blockScreen = true;

      if (this.configurationsFrotas.shared_request) {
        let beginDate = moment(this.vehicleRequest.begin_date).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        let endDate = moment(this.vehicleRequest.end_date).format(
          'YYYY-MM-DD HH:mm:ss'
        );

        this.vehicleRequestController
          .createSharedRequest({
            vehicle_id: this.vehicleRequest.vehicle_id,
            client_id: this.vehicleRequest.client_id,
            sharedRequest: this.configurationsFrotas.shared_request,
            user_id: this.user.id,
            begin_date: beginDate,
            end_date: endDate,
            pointEnd: this.selectedPoint,
          })
          .catch(error => {
            console.error(error);
            this.snackbarColor = 'error';
            this.snackbarText = error.message
              ? error.message
              : 'Erro ao solicitar reserva.';
            this.snackbar = true;
          })
          .finally(() => {
            localStorage.setItem('showInfo', String(false));
            this.$router.push('/user/informacao-reserva');
            this.blockScreen = false;
          });
      } else {
        this.vehicleRequest.card_id = null;
        this.vehicleRequest.offer = null;
        this.vehicleRequest.price_preview = null;
        this.vehicleRequest.pre_authorization_value = null;
        this.vehicleRequest.user_id = localStorage.getItem('pickn_user');

        await this.vehicleRequestController
          .create(this.vehicleRequest)
          .then(res => {
            if (this.configurations.vehicle_schedule) {
              localStorage.setItem('showInfo', Boolean(false));
              //this.Information.showInfo = localStorage.getItem("showInfo");
              this.$router.push('/user/informacao-reserva');
            } else {
              localStorage.setItem('showInfo', String(false));
              this.$router.push({
                path: `/user/reserva/${res.request.id}`,
              });
            }
          })
          .catch(error => {
            console.error(error);
            this.snackbarColor = 'error';
            this.snackbarText = error.message
              ? error.message
              : 'Erro ao solicitar reserva.';
            this.snackbar = true;
          })
          .finally(() => {
            this.blockScreen = false;
          });
      }
    },

    getTimeFromMins(mins) {
      let h = (mins / 60) | 0;
      let m = mins % 60 | 0;
      return `${h}:${('00' + m).slice(-2)}`;
    },

    selectedVehicle(data) {
      this.vehiclesSelectedGarage = data.marker;
      console.log(this.vehiclesSelectedGarage);
    },

    async scanQRCode() {
      // if (this.vehiclesInArea.length > 0) {
      let element = document.getElementById('container');
      element.classList.add('transparentBody');

      let map = document.getElementById('vehiclesMap');
      map.style.display = 'none';
      map.classList.add('transparentBody');

      let app = document.getElementById('app');
      app.classList.add('transparentBody');

      let first = document.getElementById('first');
      first.classList.add('transparentBody');

      let body = document.getElementById('body');
      body.classList.add('transparentBody');

      let mainPanel = document.getElementById('main-panel');
      mainPanel.classList.add('transparentBody');

      let wrapper = document.getElementById('wrapper');
      wrapper.classList.add('transparentBody');

      await window.QRScanner.show();

      await window.QRScanner.scan(async (err, contents) => {
        if (err) {
          if (err.name === 'SCAN_CANCELED') {
            console.error('qr code não encontrado!');
          } else {
            console.error(err._message);
          }
        }

        this.vehicleController
          .getVehicleByQrCode(contents)
          .then(vehicleScan => {
            this.vehicleRequest.vehicle_id = vehicleScan.id;
            this.vehicleRequest.vehicle.url = vehicleScan.vehicle_model.url;
            this.vehicleRequest.vehicle.brand = vehicleScan.vehicle_model.brand;
            this.vehicleRequest.vehicle.model = vehicleScan.vehicle_model.model;
            this.vehicleRequest.vehicle.plate = vehicleScan.plate;
            const begin = new Date();
            begin.setHours(begin.getHours());
            this.vehicleRequest.begin_date = moment(begin)
              .add(5, 'm')
              .toISOString(true);
            this.showFirst = false;
            this.showSecond = true;

            window.QRScanner.hide();
            element.classList.remove('transparentBody');
            map.classList.remove('transparentBody');
            app.classList.remove('transparentBody');
            first.classList.remove('transparentBody');
            body.classList.remove('transparentBody');
            mainPanel.classList.remove('transparentBody');
            wrapper.classList.remove('transparentBody');
          })
          .catch(error => {
            console.log(error);
            this.showAlert(
              'error',
              error.body.message
                ? error.body.message
                : 'Erro ao buscar veículo.'
            );
            setTimeout(() => {
              this.$router.go();
            }, 2000);
          });
      });
    },
    searchAddress(latlng) {
      var geocoder = new google.maps.Geocoder();

      geocoder
        .geocode({ location: latlng })
        .then(({ results }) => {
          if (results[0]) {
            console.log('Endereço: ', results[0].formatted_address);
            this.address = results[0].formatted_address;
          } else {
            console.log('No results found');
          }
        })
        .catch(e => console.log('Geocoder failed due to: ' + e));
    },
    async nextStep() {
      this.showSecond = !this.showSecond;
      this.showThird = !this.showThird;
      this.scroolTo();
    },

    async getConfigurationsFrotas() {
      let configs = await this.configurationController.getAllFrotasConfiguration(
        this.vehicleRequest.client_id
      );
      this.configurationsFrotas = configs;
    },

    async getPoints() {
      try {
        this.points = await this.pointController.get();
      } catch (err) {
        let message = 'Falha ao recuperar pontos';
        this.$notify('error', 'Erro', message);
      }
    },
  },
};
</script>

<style scoped>
@media (max-height: 626px) {
  .btn-invite a {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
    min-height: 58px !important;
  }
}

.colorSelected {
  color: #30508e !important;
}

.changePage .v-card {
  height: 42px;
  display: flex;
  align-items: center;
}

.changePage button {
  width: 50%;
  font-weight: 500;
  color: #2e2e2e;
  font-size: 14px;
}

.first {
  padding-top: 42px;
  height: calc(100vh - 105px) !important;
}

.home-section {
  overflow: scroll;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.cardBottom {
  height: 50%;
  min-height: 232px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  border-radius: 0;
}

.cardBottom .content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.welcome {
  position: relative;
}

.welcome img {
  width: 100%;
}

.welcome span {
  max-width: 100%;
  max-height: 100%;
  padding: 18px 16px;
  position: absolute;
  font-size: 20px;
  line-height: 27px;
  top: 0;
  left: 0;
  color: #fff;
  font-weight: 500;
}

.inputs >>> #inputDate {
  width: 100%;
  text-align: center;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}
.colorSelectedBack {
  background-color: var(--secondary-color) !important;
}
.sizeTop {
  height: 48px;
}

hr {
  width: 2px;
  height: 25px;
  margin: auto 0;
}

.button {
  margin: 0 auto;
}

.button-text {
  text-transform: none;
}

.second {
  margin-bottom: 46px;
}

.sizePart {
  width: 49%;
  text-align: center;
}

.container {
  position: relative;
  height: 100vh;
}

.cardRadius {
  border-radius: 4px;
}

.carSelected {
  border: 2px solid var(--secondary-color) !important;
}
.sharedRequest {
  background-color: var(--secondary-color) !important;
}

.cardTitle {
  font-size: 18px;
}

.cardContent {
  display: flex;
  justify-content: space-between;
}

.coupon {
  display: flex;
}

.couponBtn {
  outline: none;
}

.vehicle {
  display: flex;
}

.passageiros {
  background: #eaeaea;
  height: 39px;
}
.passageiros-text {
  font-size: 14px;
  font-family: 'Sequel';
  font-weight: 600;
  color: #555555;
}

.cardTitleV2 {
  padding: 10px;
  background: #ffffff;
  box-shadow: 0px 1px 6px 1px rgba(0, 0, 0, 0.2);
  border-radius: 4px 4px 0px 0px;
}

.modelo {
  font-size: 16px;
  font-family: 'Sequel';
  font-weight: 700;
  color: var(--secondary-color);
}
.plate {
  font-size: 12px;
  font-family: 'Sequel';
  font-weight: 355;
  color: var(--secondary-color);
}
.titulo {
  font-size: 18px;
  font-family: 'Segoe UI';
  font-weight: 400;
  color: #6d6c6b;
}
.subtitulo {
  font-size: 12px;
  font-family: 'Sequel';
  font-weight: 700;
  color: #555555;
}

.conteudo {
  border-top: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
}

.caption {
  font-size: 10px;
  font-family: 'Sequel';
  font-weight: 405;
  color: #979797;
}

.contentLeft {
  display: inline-block;
  width: 60%;
}

.contentRight {
  display: inline-block;
  width: 40%;
}

.contentBottom {
  display: inline-block;
  width: 100%;
}

.vehicleImg {
  margin-left: -10px;
}

.vdatetime {
  width: 100%;
}

.inputs {
  border: 1px solid rgb(173, 173, 173);
  border-radius: 6px;
  align-content: middle;
  width: 90%;
  margin: 0 auto;
  display: flex;
}

.border {
  border: 2px solid grey;
}

.borderBottom {
  border-bottom: 1px solid gray;
}

.bottom {
  margin-bottom: 60px;
}

.fab {
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 0 0;
  display: flex;
}

.floatBtn {
  position: absolute;
  bottom: 56px;
  width: 100%;
  margin: 0 auto;
}

.colorBtn {
  background-color: var(--secondary-color) !important;
}

.checkin {
  background-color: var(--secondary-color);
}

.checkin-text {
  color: var(--secondary-color);
}

.checkinBorder {
  border: 1px solid var(--secondary-color) !important;
}

.checkout {
  background-color: var(--orange-color) !important;
}

.checkout-text {
  color: var(--orange-color);
}

.checkoutBorder {
  border: 1px solid var(--orange-color) !important;
}

.total {
  color: #181f4d;
}

.changePage {
  position: fixed;
  top: 48px;
  z-index: 1;
}

.promotion {
  width: 100%;
  height: 95vh;
  margin: 0 auto;
}

.card-vehicle {
  /* width: 100%; */
  position: fixed;
  bottom: 60px;
  margin: 0 10px 0 10px;
}
.cardVehicle {
  color: black;
  padding-left: 20px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.qrcode-btn {
  position: fixed;
  top: 64px;
  z-index: 3;
  right: 10px;
  background-color: white !important;
  height: 60px !important;
}

.transparentBody {
  background: none transparent !important;
  background-color: none !important;
}

.point {
  font-size: 14px;
  font-weight: 700;
  color: #555555;
}
.selectPoint {
  font-size: 14px;
  color: #555555;
}
</style>
